import script from "./formGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./formGenerator.vue?vue&type=script&setup=true&lang=js"

import "./formGenerator.vue?vue&type=style&index=0&id=76a4e9cd&scoped=true&lang=css"

import exportComponent from "/jenkins/workspace/zh-workflow-frontend_prev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76a4e9cd"]])

export default __exports__